import { ContractReviewListItemContent } from './components/listItemContent/ContractReviewListItemContent'
import { ContractReviewPreviewHeaderContent } from './components/previewHeaderContent/ContractReviewPreviewHeaderContent'
import { ContractReviewContent } from './components/reviewContent/ContractReviewContent'

export const contractReviewManualTask = {
  previewHeaderContent: ContractReviewPreviewHeaderContent,
  reviewContent: ContractReviewContent,
  listItemContent: ContractReviewListItemContent
}

export * as ContractReviewTask from './types'
